import axios from "~/plugins/axios";

export default {
  all() {
    return axios.get("/web_api/v1/static_search/").then((response) => response.data);
  },
  allWithFavorites(userId, includes = []) {
    return axios.post("/web_api/v1/static_search/with_favorites/", {
      user_id: userId,
    }, { params: { include: includes } }).then((response) => response.data);
  },
  onlyFavorites(userId, includes = []) {
    return axios.post("/web_api/v1/static_search/only_favorites/", {
      user_id: userId,
    }, { params: { include: includes } }).then((response) => response.data);
  },
  getCategoryInformation(categoryKey) {
    return axios.post("/web_api/v1/static_search/category_information/", { categoryKey }).then((response) => response.data);
  },
  getStaticSearch(key, routeParameters) {
    return axios.post(`/web_api/v1/static_search/${key}`, routeParameters).then((response) => response.data);
  },
  getCategories() {
    return axios.get("/web_api/v1/static_search/categories").then((response) => response.data);
  },
  setFavorite(staticSearchId, userId, includes = []) {
    return axios.post("/web_api/v1/static_search/set_favorite/", {
      static_search_id: staticSearchId,
      user_id: userId,
    }, { params: { include: includes } }).then((response) => response.data);
  },
  unsetFavorite(staticSearchId, userId, includes = []) {
    return axios.post("/web_api/v1/static_search/unset_favorite/", {
      static_search_id: staticSearchId,
      user_id: userId,
    }, { params: { include: includes } }).then((response) => response.data);
  },
  flushCache() {
    return axios.get("/web_api/v1/static_search/flush_cache").then((response) => response.data);
  },
};
